import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { AuthInput } from 'components/AuthInput/AuthInput';
import { userApi } from 'helpers/api/user';

const phoneMask = '+380 99 999 99 99';
const phonePlaceHolder = '+380 XX XXX XX XX';
const intervalSeconds = 15;

export const PasswordResetForm = ({ pending, onSubmit }) => {
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [smsCode, setSmsCode] = useState('');
  const [SMSShow, setSMSShow] = useState(false);
  const handleEmail = (value) => setEmail(value);
  const handlePhoneNumber = (value) => setPhoneNumber(value);
  const [counter, setCounter] = useState(intervalSeconds);
  const [counterShow, setCounterShow] = useState(false);
  const handleSmsCode = (value) => setSmsCode(value);

  const handleSendSms = () => {
    setSMSShow(true);
    setCounterShow(true);
    userApi.messageSend({ phone_number: phoneNumber });
    let timerId = setInterval(() => setCounter((counter) => counter - 1), 1000);
    setTimeout(() => {
      clearInterval(timerId);
      setCounter(intervalSeconds);
      setCounterShow(false);
    }, intervalSeconds * 1000);
  };

  const isPhoneValid = () => phoneNumber && !phoneNumber.includes('X');
  const isSMSValid = () => smsCode && !smsCode.includes('X');

  const handleSubmit = (e) => {
    if (pending) {
      return;
    }

    onSubmit({
      email,
      phoneNumber,
      smsCode,
    });
  };

  return (
    <div className="login-block">
      <div className="login-block-title">Восстановление пароля</div>

      <div className="login-block-container">
        <form>
          <Input type="text" placeholder="Введите email" value={email} onChange={handleEmail} required={true} />
          или
          <div className="phone-number">
            <div className="phone-number-grid-element left">
              <AuthInput
                value={phoneNumber}
                onChange={handlePhoneNumber}
                required={true}
                mask={phoneMask}
                placeholder={phonePlaceHolder}
              />
            </div>
            <div className="phone-number-grid-element right">
              <Button
                onClick={handleSendSms}
                className={cn('btn-phone', (pending || !isPhoneValid() || counterShow) && 'disabled-button')}
                disabled={pending || !isPhoneValid() || counterShow}
                loader={pending}
              >
                Отправить код
              </Button>
            </div>
          </div>
          {SMSShow && (
            <>
              {counterShow && <span className="counterShow"> Отправить код повторно сможете через {counter} сек.</span>}
              <AuthInput mask="99 99" placeholder="XX XX" value={smsCode} onChange={handleSmsCode} required={true} />
            </>
          )}
          <Button
            onClick={handleSubmit}
            className={cn('btn-form', (pending || (!email && !isSMSValid())) && 'disabled-button')}
            disabled={pending || (!email && !isSMSValid())}
            loader={pending}
          >
            Продолжить
          </Button>
        </form>
      </div>
    </div>
  );
};

PasswordResetForm.propTypes = {
  pending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

PasswordResetForm.defaultProps = {
  pending: false,
};
